import * as React from "react";

const CENErrorIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.332 14.7168L11.083 4.05273C10.6046 3.23242 9.39724 3.23242 8.9156 4.05273L2.66949 14.7168C2.18873 15.5342 2.78753 16.5625 3.75114 16.5625H16.2492C17.209 16.5625 17.8096 15.5371 17.332 14.7168ZM9.29587 7.42188C9.29587 7.03369 9.61081 6.71875 9.999 6.71875C10.3872 6.71875 10.7021 7.03516 10.7021 7.42188V11.1719C10.7021 11.5601 10.3872 11.875 10.0254 11.875C9.66355 11.875 9.29587 11.5615 9.29587 11.1719V7.42188ZM9.999 14.6875C9.4904 14.6875 9.0779 14.275 9.0779 13.7664C9.0779 13.2578 9.49011 12.8453 9.999 12.8453C10.5079 12.8453 10.9201 13.2578 10.9201 13.7664C10.9189 14.2744 10.5088 14.6875 9.999 14.6875Z"
                fill="#ED0000"
            />
        </svg>
    );
};

export default React.memo(CENErrorIcon);
